const ENVIRONMENTS = {
  DEVELOPMENT: 'DEVELOPMENT',
  PRODUCTION: 'PRODUCTION'
}
export default ENVIRONMENTS
export { ENVIRONMENTS }
